import { css } from '@emotion/react'
import { Icon } from '@iconify/react'
import { Button, Stack, theme, Typography } from '@nexans/react-ui-kit'
import { useTranslation } from 'react-i18next'

import { LEGAL_NOTICE } from '@/config/env'
import { getLegalNoticeUrl } from '@/config/legal'

const HELP_CENTER_URL = 'https://www.youtube.com/playlist?list=PLFAG-Yh_ipZ8i1Fxw-hptzuQrjPt8qyHJ'

const AuthFooter = () => {
  const { t, i18n } = useTranslation('common')
  const year = new Date().getFullYear()

  const language = i18n.language?.split('-')[0] || 'en'
  const legalNoticeUrl = LEGAL_NOTICE ? getLegalNoticeUrl(language) : '#'

  return (
    <Stack align="center" css={styles.root} spacing="md" fullWidth>
      <Typography css={styles.caption} textAlign="center" variant="body1">
        {t('footer.copyright', { year })}
      </Typography>

      <Stack align="center" css={styles.linksRow} direction="horizontal" spacing="lg" fullWidth>
        <Button
          color="primary"
          icon={<Icon height={18} icon="mdi:help-circle-outline" width={18} />}
          variant="text"
          onClick={() => window.open(HELP_CENTER_URL, '_blank', 'noopener,noreferrer')}
        >
          {t('footer.need_help')}
        </Button>

        <Button
          color="primary"
          icon={<Icon height={18} icon="mdi:file-document-outline" width={18} />}
          variant="text"
          onClick={() => window.open(legalNoticeUrl, '_blank', 'noopener,noreferrer')}
        >
          {t('footer.terms_of_services')}
        </Button>
      </Stack>
    </Stack>
  )
}

const styles = {
  root: css({
    padding: `${theme.spacings.lg} ${theme.spacings.xl}`,
  }),
  caption: css({
    color: theme.colors.gray[500],
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
  }),
  linksRow: css({
    flexWrap: 'wrap',
    justifyContent: 'center',
  }),
}

export { AuthFooter }
